export interface GuideImage {
  image: string;
  imageAlt: string;
}

const GUIDE_IMAGES: Record<string, GuideImage> = {
  "mowing-steep-slopes-safely": {
    image: "/images/guides/guide-mowing-steep-slopes-safely.jpg",
    imageAlt: "A rural property owner assessing a steep grassy Australian hillside from level ground",
  },
  "best-all-terrain-mowers-australia": {
    image: "/images/guides/guide-best-all-terrain-mowers-australia.jpg",
    imageAlt: "A tracked mower crossing tussocks and uneven ground on an Australian paddock",
  },
  "diy-remote-control-lawn-mower": {
    image: "/images/guides/guide-diy-remote-control-lawn-mower.jpg",
    imageAlt: "An unfinished remote-control lawn mower project on a workshop bench",
  },
  "where-to-buy-robot-remote-control-mowers-australia": {
    image: "/images/guides/guide-where-to-buy-robot-remote-control-mowers-australia.jpg",
    imageAlt: "A customer comparing robot and remote-control mowers in a specialist showroom",
  },
  "robot-mower-comparison-australia": {
    image: "/images/guides/guide-robot-mower-comparison-australia.jpg",
    imageAlt: "Five different robotic lawn mower designs arranged for comparison",
  },
  "autonomous-mowing-australia-whats-next": {
    image: "/images/guides/guide-autonomous-mowing-australia-whats-next.jpg",
    imageAlt: "An autonomous electric mower navigating an Australian acreage lawn at dawn",
  },
  "flail-mower-guide": {
    image: "/images/guides/guide-flail-mower-guide.jpg",
    imageAlt: "A flail mower cutting dense long grass and leaving a mulched strip",
  },
  "remote-control-flail-mower-guide": {
    image: "/images/guides/guide-remote-control-flail-mower-guide.jpg",
    imageAlt: "An operator controlling a tracked flail mower from a clear distance",
  },
  "flail-mower-vs-slasher-vs-mulcher": {
    image: "/images/guides/guide-flail-mower-vs-slasher-vs-mulcher.jpg",
    imageAlt: "Flail mower, slasher and mulcher working on separate paddock strips",
  },
  "tractor-excavator-flail-mowers-vs-self-propelled": {
    image: "/images/guides/guide-tractor-excavator-flail-mowers-vs-self-propelled.jpg",
    imageAlt: "Tractor, excavator and self-propelled flail mower configurations lined up on site",
  },
  "flail-mower-buying-guide-australia": {
    image: "/images/guides/guide-flail-mower-buying-guide-australia.jpg",
    imageAlt: "A buyer inspecting new, used and hire flail mower options in an equipment yard",
  },
  "commercial-remote-control-mowers": {
    image: "/images/guides/guide-commercial-remote-control-mowers.jpg",
    imageAlt: "A vegetation crew using a remote-control mower on a roadside embankment",
  },
  "robot-mowers-for-acreage": {
    image: "/images/guides/guide-robot-mowers-for-acreage.jpg",
    imageAlt: "A robot mower working within a defined lawn zone on an Australian acreage property",
  },
  "robot-lawn-mowers-australia-guide": {
    image: "/images/guides/guide-robot-lawn-mowers-australia-guide.jpg",
    imageAlt: "A robotic lawn mower and charging dock in an Australian native garden",
  },
  "robot-mower-vs-remote-control-mower": {
    image: "/images/guides/guide-robot-mower-vs-remote-control-mower.jpg",
    imageAlt: "A robot lawn mower and tracked remote-control mower working on different terrain",
  },
  "best-robot-lawn-mowers-australia": {
    image: "/images/guides/guide-best-robot-lawn-mowers-australia.jpg",
    imageAlt: "Several robotic lawn mower styles arranged across a landscaped Australian lawn",
  },
  "robot-mower-prices-australia": {
    image: "/images/guides/guide-robot-mower-prices-australia.jpg",
    imageAlt: "Three robotic lawn mower tiers displayed from compact to premium",
  },
  "best-mower-steep-slopes": {
    image: "/images/guides/guide-best-mower-steep-slopes.jpg",
    imageAlt: "A low-profile tracked mower working on a steep Australian hillside",
  },
  "robot-mowers-australian-acreage-questions": {
    image: "/images/guides/guide-robot-mowers-australian-acreage-questions.jpg",
    imageAlt: "An acreage owner assessing lawn zones, gates and paddocks with a property map",
  },
  "remote-controlled-vs-autonomous-mowers": {
    image: "/images/guides/guide-remote-controlled-vs-autonomous-mowers.jpg",
    imageAlt: "Remote-controlled and autonomous mowers working on rough grass and lawn",
  },
  "flail-mowers-rough-australian-ground": {
    image: "/images/guides/guide-flail-mowers-rough-australian-ground.jpg",
    imageAlt: "A flail mower processing thick weeds and sticks on rough Australian ground",
  },
  "compare-remote-controlled-mowers-australia": {
    image: "/images/guides/guide-compare-remote-controlled-mowers-australia.jpg",
    imageAlt: "Three different remote-control mower configurations lined up for comparison",
  },
  "planning-slope-mowing-australian-acreage": {
    image: "/images/guides/guide-planning-slope-mowing-australian-acreage.jpg",
    imageAlt: "A hillside property being assessed for slope mowing zones and access",
  },
  "remote-mower-planning-commercial-vegetation-work": {
    image: "/images/guides/guide-remote-mower-planning-commercial-vegetation-work.jpg",
    imageAlt: "A site supervisor planning remote mower work along a vegetation corridor",
  },
  "bushfire-fuel-reduction-mowing-vs-burning": {
    image: "/images/guides/guide-bushfire-fuel-reduction-mowing-vs-burning.jpg",
    imageAlt: "Mechanical fuel reduction beside an Australian bushland edge",
  },
  "safe-mowing-angles-rollover-risk": {
    image: "/images/guides/guide-safe-mowing-angles-rollover-risk.jpg",
    imageAlt: "An operator measuring the angle of a steep grassy slope before mowing",
  },
  "husqvarna-automower-australia-guide": {
    image: "/images/guides/guide-husqvarna-automower-australia-guide.jpg",
    imageAlt: "A premium robotic lawn mower maintaining a structured Australian suburban garden",
  },
  "segway-navimow-australia-guide": {
    image: "/images/guides/guide-segway-navimow-australia-guide.jpg",
    imageAlt: "A wire-free robotic mower working within mapped zones on an open Australian lawn",
  },
  "eufy-robot-mower-australia-guide": {
    image: "/images/guides/guide-eufy-robot-mower-australia-guide.jpg",
    imageAlt: "A compact vision-guided robotic mower following a crisp suburban lawn edge",
  },
  "roborock-mower-australia-guide": {
    image: "/images/guides/guide-roborock-mower-australia-guide.jpg",
    imageAlt: "A rugged robotic lawn mower crossing gently uneven landscaped turf",
  },
  "gardena-robot-mower-australia-guide": {
    image: "/images/guides/guide-gardena-robot-mower-australia-guide.jpg",
    imageAlt: "A compact robotic mower navigating a lush residential garden with narrow lawn corridors",
  },
  "worx-landroid-australia-guide": {
    image: "/images/guides/guide-worx-landroid-australia-guide.jpg",
    imageAlt: "A robotic lawn mower maintaining a practical Australian family backyard",
  },
  "segway-navimow-vs-husqvarna-automower": {
    image: "/images/guides/guide-segway-navimow-vs-husqvarna-automower.jpg",
    imageAlt: "Two different robotic lawn mower systems arranged for an Australian lawn comparison",
  },
  "eufy-vs-roborock-robot-mower": {
    image: "/images/guides/guide-eufy-vs-roborock-robot-mower.jpg",
    imageAlt: "Compact vision-guided and rugged robotic lawn mowers compared on landscaped turf",
  },
  "segway-navimow-vs-eufy-robot-mower": {
    image: "/images/guides/guide-segway-navimow-vs-eufy-robot-mower.jpg",
    imageAlt: "Satellite-guided and vision-guided robotic lawn mowers working on adjacent lawn zones",
  },
  "robot-mower-bunnings-australia": {
    image: "/images/guides/guide-robot-mower-bunnings-australia.jpg",
    imageAlt: "Robotic lawn mower displays in an Australian garden equipment retail aisle",
  },
  "robot-mower-garage-storage-australia": {
    image: "/images/guides/guide-robot-mower-garage-storage-australia.jpg",
    imageAlt: "A robotic lawn mower sheltered beside its charging dock from Australian sun and storms",
  },
  "wire-free-robot-mowers-rtk-gps": {
    image: "/images/guides/guide-wire-free-robot-mowers-rtk-gps.jpg",
    imageAlt: "A wire-free robotic mower using a satellite base station on a rural Australian lawn",
  },
  "cheapest-robot-mowers-australia": {
    image: "/images/guides/guide-cheapest-robot-mowers-australia.jpg",
    imageAlt: "Entry-level robotic lawn mowers arranged for a practical Australian buyer comparison",
  },
  "electric-robot-remote-control-mowers": {
    image: "/images/guides/guide-electric-robot-remote-control-mowers.jpg",
    imageAlt: "Battery-powered robotic and tracked remote-control mowers on an Australian acreage property",
  },
  "commercial-robot-mowers-australia": {
    image: "/images/guides/guide-commercial-robot-mowers-australia.jpg",
    imageAlt: "A fleet of commercial autonomous turf mowers maintaining an Australian sports field",
  },
  "heavy-duty-awd-robot-mowers": {
    image: "/images/guides/guide-heavy-duty-awd-robot-mowers.jpg",
    imageAlt: "A rugged all-wheel-drive robotic mower working on steep maintained turf near rough vegetation",
  },
  "flail-mowers-for-tractors-pto-guide": {
    image: "/images/guides/guide-flail-mowers-for-tractors-pto-guide.jpg",
    imageAlt: "A compact tractor operating a three-point-linkage PTO flail mower in an Australian paddock",
  },
  "excavator-flail-mowers-guide": {
    image: "/images/guides/guide-excavator-flail-mowers-guide.jpg",
    imageAlt: "An excavator using a hydraulic flail head to reach a steep Australian creek bank",
  },
  "atv-quad-towable-flail-mowers": {
    image: "/images/guides/guide-atv-quad-towable-flail-mowers.jpg",
    imageAlt: "A utility ATV towing a self-powered flail mower across a small acreage paddock",
  },
  "skid-steer-bobcat-flail-mowers": {
    image: "/images/guides/guide-skid-steer-bobcat-flail-mowers.jpg",
    imageAlt: "A skid steer operating a front-mounted hydraulic flail mower on scrubby ground",
  },
  "flail-mower-blades-hammers-guide": {
    image: "/images/guides/guide-flail-mower-blades-hammers-guide.jpg",
    imageAlt: "Matched Y-shaped flail knives and heavy hammer flails arranged for workshop inspection",
  },
  "flail-mower-hire-australia": {
    image: "/images/guides/guide-flail-mower-hire-australia.jpg",
    imageAlt: "Flail mower attachments being inspected in an Australian equipment hire yard",
  },
  "australian-flail-mower-brands-compared": {
    image: "/images/guides/guide-australian-flail-mower-brands-compared.jpg",
    imageAlt: "Different tractor flail mower attachment styles lined up in an Australian machinery yard",
  },
  "orchard-vineyard-mowing-guide": {
    image: "/images/guides/guide-orchard-vineyard-mowing-guide.jpg",
    imageAlt: "A tracked remote-control flail mower maintaining clean rows in an Australian vineyard",
  },
  "verge-roadside-mowing-councils": {
    image: "/images/guides/guide-verge-roadside-mowing-councils.jpg",
    imageAlt: "A remote-control flail mower working on a managed Australian roadside batter",
  },
  "small-robot-lawn-mowers": {
    image: "/images/guides/guide-small-robot-lawn-mowers.jpg",
    imageAlt: "A compact robot mower navigating a narrow passage in a small Australian courtyard lawn",
  },
  "robot-reel-mowers": {
    image: "/images/guides/guide-robot-reel-mowers.jpg",
    imageAlt: "A precision cylinder reel assembly beside an autonomous mower on fine turf",
  },
  "second-hand-flail-mower-checklist": {
    image: "/images/guides/guide-second-hand-flail-mower-checklist.jpg",
    imageAlt: "A buyer inspecting the rotor and drive components of a used flail mower",
  },
  "hayes-flail-mowers-overview": {
    image: "/images/guides/guide-hayes-flail-mowers-overview.jpg",
    imageAlt: "A tow-behind flail mower attachment in an Australian rural equipment yard",
  },
};

const imagePaths = Object.values(GUIDE_IMAGES).map(({ image }) => image);
if (new Set(imagePaths).size !== imagePaths.length) {
  throw new Error("Every blog and guide must use a unique image path");
}

export function getGuideImage(slug: string): GuideImage {
  const image = GUIDE_IMAGES[slug];
  if (!image) {
    throw new Error(`Missing dedicated guide image for "${slug}"`);
  }
  return image;
}